import { useEffect, useRef, useState } from 'react';
import { StreamClient, type StreamStatus } from '../lib/socket';

export interface UseStreamOptions<T> {
  path: string;
  label: string;
  onFrame: (frame: T) => void;
  enabled?: boolean;
}

export function useStream<T>({
  path,
  label,
  onFrame,
  enabled = true,
}: UseStreamOptions<T>): StreamStatus {
  const [status, setStatus] = useState<StreamStatus>('connecting');
  const handlerRef = useRef(onFrame);
  handlerRef.current = onFrame;

  useEffect(() => {
    if (!enabled) {
      setStatus('closed');
      return;
    }
    const client = new StreamClient<T>({
      path,
      label,
      onFrame: (frame) => handlerRef.current(frame),
      onStatus: setStatus,
    });
    client.start();
    return () => client.dispose();
  }, [path, label, enabled]);

  return status;
}
